import React from "react";
//import { Link } from "react-router-dom";
import './ContactUs.css';
import { motion } from "framer-motion";
import PageTitle from "../components/PageTitle";
import contactImg from '../assets/images/contact-us-light-updated.png';
import ContactForm from "../components/individual/ContactForm";

const Contact = () => {
  return (
    <>
      <PageTitle
        title="お問い合わせ"
        description="Get in touch with DG Future Tech. We're here to answer your questions and provide the IT support you need."
      />

      <div className="contact-page-wrapper">

        <div className="contact-content">

          {/* Left Column: Intro + Illustration */}
          <div className="contact-intro">
            <h1 className="contact-heading">お問い合わせ</h1>
            <p className="contact-description">
              このたびは当社サービスにご関心をお寄せいただき誠にありがとうございます。お手数ではございますが、下記お問い合わせフォームにお問い合わせ内容をご記入の上、送信ボタンを押してください。
            </p>
            <img
              src={contactImg}
              alt="お問い合わせ"
              className="contact-illustration"
            />
          </div>

          {/* Right Column: Contact Form Card */}
          <div className="contact-form-wrapper">
            <ContactForm />
          </div>

        </div>
      </div>
    </>
  );
};

export default Contact;